import { TripFolder } from '../../lib/types/models/trip-folder/trip-folder'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripFolder(id: number) {
  return restApiClient.url(constructApiUrl(API.tripFolder.get.url, { id })).get<TripFolder>()
}
